// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
// ** ThemeConfig Import
import { API_URL } from '@configs/endpoint'
export const getTags = createAsyncThunk("tags/getTags", async () => {
    const response = await axios.get(`${API_URL}/tags`)
    const data = await response.data.tags
    return data
})
export const syncTags = createAsyncThunk("tags/syncTags", async (_, { dispatch }) => {
    const response = await axios.post(`${API_URL}/tags/sync`)
    dispatch(getTags())
    return response.data
})
export const tags = createSlice({
    name: "tags",
    initialState: {
        data: [],
        allData: [],
        selectedTag: {},
        isLoading: true,
        isSyncing: false,
        isError: false,
        sort: "views", // default sort
        total: 0,
        currentPage: 1,
        rowsPerPage: 10,
        searchText: "",
    },
    reducers: {
        startFetchTags: (state) => {
            state.isLoading = true
            state.isError = false
        },
        successFetchTags: (state, action) => {
            state.data = action.payload.slice(0, state.rowsPerPage)
            state.allData = action.payload
            state.total = action.payload.length
            state.isLoading = false
        },
        changePage: (state, action) => {
            state.currentPage = action.payload
            state.data = state.allData.slice(action.payload * state.rowsPerPage - state.rowsPerPage, action.payload * state.rowsPerPage)
        },
        changeRowsPerPage: (state, action) => {
            state.rowsPerPage = action.payload
            state.data = state.allData.slice(0, action.payload)
            state.currentPage = 1
        },
        changeSearchTerm: (state, action) => {
            state.searchText = action.payload
            // if (action.payload !== ""){
            //     state.data = state.allData.filter(post => post.title.toLowerCase().includes(action.payload))
            //     state.currentPage = 1
            // }else{
            //     state.data = state.allData.slice(0, state.rowsPerPage)
            //     state.currentPage = 1
            // }
        },
        setSelectedTag: (state, action) => {
            state.selectedTag = action.payload
        },
        filterTags: (state, action) => {
            state.searchText = action.payload
            state.data = state.allData.filter(tag => tag.name.toLowerCase().includes(action.payload.toLowerCase()))
        },
        sortTags: (state, action) => {
            state.sort = action.payload
            state.allData = state.allData.sort((a, b) => {
                if (action.payload === 'views') {
                    return (b.post_count?.views || 0) - (a.post_count?.views || 0)
                } else if (action.payload === 'count') {
                    return (b.post_count?.count || 0) - (a.post_count?.count || 0)
                } else if (action.payload === 'name') {
                    return a.name.localeCompare(b.name)
                }
                return 0
            })
            state.data = [...state.allData]
        }
    },
    extraReducers: builder => {
        builder.addCase(getTags.fulfilled, (state, action) => {
            const sorted = action.payload.sort((a, b) => (b.post_count?.views || 0) - (a.post_count?.views || 0))
            state.data = sorted
            state.allData = sorted
            state.total = action.payload.length
            state.isLoading = false
        })
        builder.addCase(syncTags.pending, (state) => {
            state.isSyncing = true
        })
        builder.addCase(syncTags.fulfilled, (state) => {
            state.isSyncing = false
        })
        builder.addCase(syncTags.rejected, (state) => {
            state.isSyncing = false
        })
    }
})
export const {
    startFetchTags, successFetchTags, changePage, changeRowsPerPage,
    setSelectedTag, filterTags,
    changeSearchTerm, sortTags
} = tags.actions
export default tags.reducer
